<template>
  <div class="Message">
      <b-container>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <h2 class="heading">Message from the Chairman & Commissioner</h2>
                        <p class="description" v-html="acf.acf.message_description"></p>
                        <img class="signature" src="https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/Keith-Waters.png">
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <div class="above768">
                            <div v-for="(i, index) in acf.acf.message_section_one" :key="index">
                                <b-row class="itemRow">
                                    <b-col lg="3" class="noPad">
                                        <img class="Leftimage" :src="i.image">
                                    </b-col>
                                    <b-col class="noPad">
                                        <h2 class="itemsTitle" v-html="i.item_title"></h2>
                                        <p class="itemsLeft" v-html="i.item_one"></p>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                        <div class="below768 belowSec">
                            <div v-for="(i, index) in acf.acf.message_section_one" :key="index">
                                <b-row class="">
                                    <b-col sm="2" class="noPadMob">
                                        <img class="Leftimage" :src="i.image">
                                    </b-col>
                                    <b-col sm="10" class="noPadMob">
                                        <h2 class="itemsTitle" v-html="i.item_title"></h2>
                                        <p class="itemsLeft" v-html="i.item_one"></p>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
      </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Message',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-mena.ocs-software.com/' + "/wp-json/wp/v2/pages/8"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.below768.belowSec {
    margin-top: 35px;
}
.noPadMob.col-sm-2 {
    width: 25%;
}
.noPadMob.col-sm-10 {
    width: 75%;
}
.signature {
    width: 200px;
}
.itemRow {
    margin-bottom: 80px;
}
.itemsTitle {
    color: #C8102E;
    font-size: 40px;
}
.Leftimage {
    width: 87px;
    height: 87px;
}
.Allbuttons {
    width: 420px;
    height: 50px;
    background: transparent;
    color: #fff;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #C8102E;
    font-size: 16px;
    position: absolute;
    bottom: 0;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
    width: 420px;
    height: 50px;
    background: #C8102E;
    color: #fff;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    position: absolute;
    bottom: 0;
    transform: translateY(-10px);
}
.arrow {
    width: 14px;
    height: 12px;
}
.noPad {
    /* padding: 0; */
}
.Message {
    background-color: #fff;
    padding: 3%;
    padding-bottom: 90px;
    padding-top: 90px;
}
.heading {
    font-weight: 600;
    font-size: 40px;
    color: #152229;
}
/* mobile code */
.containterInside.container.mobContainer {
    padding-top: 40px;
    padding-bottom: 40px;
}
/* End of mobile code */
.description {
    text-align: left;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #152229;
    font-size: 20px;
}
.space {
    margin-top: 30px;
}
.bkImageFull {
    background-color: #000000; /* For browsers that do not support gradients */
}
.containterInside {
    padding-top: 100px;
    padding-bottom: 100px;
}
h2.MainTitle {
    font-size: 28px;
    color: #9CD58A;
    font-weight: bold;
    text-align: left;
}
.image {
    width: 100%;
}
.itemsLeft {
    text-align: left;
    color: #152229;
    font-size: 20px;
    /* display: flex; */
    margin-bottom: 20px;
}
.SubTitle {
    color: #9CD58A;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-top: 30px;
    margin-bottom: 20px;
}
.belowSec {
    padding-top: marpx;
}
@media only screen and (min-width: 769px) {
    .below768 {
        display: none;
    }
}
@media only screen and (max-width: 768px) {
    .above768 {
        display: none;
    }
    .itemRow {
        margin-bottom: 20px;
        margin-top: 30px;
    }
    .noPad.col-lg-3 {
        text-align: center;
    }
    .itemsTitle{
        color: #C8102E;
        font-size: 25px;
        text-align: left;
    }
    .itemsLeft {
        text-align: left;
        color: #152229;
        font-size: 18px;
        /* display: flex; */
        margin-bottom: 20px;
    }
    .Leftimage {
        width: 60px;
        height: 60px;
    }
    .Message {
        background-color: #fff;
        padding: 3%;
        padding-bottom: 25px;
        padding-top: 25px;
    }
}
</style>
